import { defineComponent as _defineComponent } from 'vue'


interface Props {
	/**
	 * 見出し文言。
	 */
	title: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    title: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * 見出し文言。
	 */
	title: string;
}
/**
 * コミュニティトークのタイトル。
 */



const __returned__ = { props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})